import { render, staticRenderFns } from "./imageselect.vue?vue&type=template&id=451a2932&scoped=true&"
import script from "./imageselect.vue?vue&type=script&lang=js&"
export * from "./imageselect.vue?vue&type=script&lang=js&"
import style0 from "./imageselect.vue?vue&type=style&index=0&id=451a2932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451a2932",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('451a2932')) {
      api.createRecord('451a2932', component.options)
    } else {
      api.reload('451a2932', component.options)
    }
    module.hot.accept("./imageselect.vue?vue&type=template&id=451a2932&scoped=true&", function () {
      api.rerender('451a2932', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/imageselect.vue"
export default component.exports